import { CSSProperties } from 'react';

import cx from 'classnames';

import './CardBase.less';

export type CardBaseProps = {
  children: React.ReactNode;
  externalLink?: string;
  internalLink?: string | null;
  className?: string;
  style?: CSSProperties;
  isLink?: boolean;
  onClick?: (event: React.MouseEvent) => void;
};

const CardBase = (props: CardBaseProps) => {
  const { children, externalLink, internalLink, className, isLink = true, onClick, style } = props;
  const hasLink = isLink && typeof (internalLink || externalLink) === 'string';
  const classes = cx('marketplace__card-base', hasLink ? 'clickable' : 'not-clickable', className);

  if (!hasLink) {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div className={classes} style={style} onClick={onClick}>
        {children}
      </div>
    );
  }

  if (internalLink) {
    return (
      <a className={classes} style={style} href={internalLink} onClick={onClick} target="_blank">
        {children}
      </a>
    );
  }

  return (
    <a className={classes} style={style} href={externalLink} onClick={onClick}>
      {children}
    </a>
  );
};

export default CardBase;
